(() => {
  function initializeBsaExperience() {
    document.documentElement.classList.add('bsa-js');
    const elements = document.querySelectorAll('[data-bsa-reveal]');

    if (!elements.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });

    elements.forEach((element) => observer.observe(element));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBsaExperience, { once: true });
  } else {
    initializeBsaExperience();
  }
})();
